/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "NavigationItemsApi",
            "endpoint": "https://44s71gacd8.execute-api.us-west-2.amazonaws.com/production",
            "region": "us-west-2"
        },
        {
            "name": "SalesExp",
            "endpoint": "https://kiouhdkek2.execute-api.us-west-2.amazonaws.com/production",
            "region": "us-west-2"
        }
    ]
};


export default awsmobile;
